export default __webpack_public_path__ + "54eddc3254b1fe9cb04ff3488c650f47.svg";